"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useViewportBreakpoint } from "@/hooks/browser/viewport/use-viewport-breakpoint.hook";
import { useCurrentUrl } from "@/hooks/use-current-url.hook";
import type { SiteDomain } from "@/services/api/content/models/site.types";
import type { ServerConfiguration } from "@/services/configuration/server-configuration.types";
import { useCookiebotConsent } from "@/vendors/Cookiebot/_hooks/use-cookiebot-consent.hook";
import type { DomId } from "@/vendors/GoogleTag/config/ad-slots.config";
import { defineGoogleAdSlot } from "@/vendors/GoogleTag/utilities/define-google-ad-slot";
export type SetupAdsProps = {
  readonly domIds: ReadonlyArray<DomId>;
  readonly domain: ServerConfiguration.AdUnitDomain | SiteDomain; // Allow for test domains
};
const timeout = 1000;

/** The script itself is loaded inside _document, as it HAS to be loaded in head. */
export function useSetupAds(t0) {
  const $ = _c(12);
  const {
    domain,
    domIds
  } = t0;
  const {
    marketing: hasMarketingConsent,
    submitted: hasSetConsent
  } = useCookiebotConsent();
  const {
    currentBreakpoint,
    isMobile,
    is3XlDesktop
  } = useViewportBreakpoint();
  const {
    relative: currentUrl
  } = useCurrentUrl();
  const adUnitPath = `/${83172459}/${domain}/${hasMarketingConsent ? "web" : "web_noconsent"}/`;
  let t1;
  if ($[0] !== adUnitPath || $[1] !== currentBreakpoint || $[2] !== currentUrl || $[3] !== domIds || $[4] !== hasSetConsent) {
    t1 = () => {
      if (currentUrl === "" || currentBreakpoint === null || !hasSetConsent) {
        return;
      }
      window.googletag = window.googletag || {
        cmd: []
      };
      const {
        googletag
      } = window;
      googletag.cmd.push(() => {
        googletag.destroySlots();
        googletag.setConfig({
          centering: true,
          collapseDiv: "BEFORE_FETCH"
        });
        for (const domId of domIds) {
          defineGoogleAdSlot(domId, adUnitPath);
        }
        googletag.setConfig({
          lazyLoad: {},
          singleRequest: true
        });
        googletag.enableServices();
      }, () => {
        for (const domId_0 of domIds) {
          waitForElementAndDisplay(domId_0);
        }
      });
    };
    $[0] = adUnitPath;
    $[1] = currentBreakpoint;
    $[2] = currentUrl;
    $[3] = domIds;
    $[4] = hasSetConsent;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== currentUrl || $[7] !== hasMarketingConsent || $[8] !== hasSetConsent || $[9] !== is3XlDesktop || $[10] !== isMobile) {
    t2 = [currentUrl, isMobile, is3XlDesktop, hasMarketingConsent, hasSetConsent];
    $[6] = currentUrl;
    $[7] = hasMarketingConsent;
    $[8] = hasSetConsent;
    $[9] = is3XlDesktop;
    $[10] = isMobile;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  useEffect(t1, t2);
}
function waitForElementAndDisplay(domId: string) {
  if (document.getElementById(domId)) {
    window.googletag.display(domId);
  } else {
    setTimeout(() => waitForElementAndDisplay(domId), timeout);
  }
}